import React from 'react'

import { UseKeyBindingProps, useKeyBindings } from './use-key-bindings'

export function withKeyBindings<T extends {}>(WrappedComponent: React.ComponentType<T>) {
  function WithKeyBindings(props: Omit<T, keyof UseKeyBindingProps>) {
    const useKeyBindingsProps = useKeyBindings()

    return <WrappedComponent {...(props as T)} {...useKeyBindingsProps} />
  }

  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  WithKeyBindings.displayName = `withKeyBindings(${displayName})`

  return WithKeyBindings
}
